import React from 'react';
import { Link } from 'react-router-dom';
import {
  Facebook,
  Twitter,
  Linkedin,
  Instagram,
  Mail,
  Phone,
  MapPin
} from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#2C3E50] text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">

          {/* Company Info */}
          <div>
            <img
              src="/logo.png"
              alt="Capital IQ Logo"
              className="h-14 w-auto mb-4"
            />

            <p className="text-gray-300 mb-4 leading-relaxed">
              Your trusted partner for comprehensive financial solutions including
              loans, portfolio management, and insurance services.
            </p>

            <div className="flex items-center gap-4">
              <a
                href="#"
                className="w-10 h-10 bg-white/10 hover:bg-[#DC143C] rounded-full flex items-center justify-center transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/10 hover:bg-[#DC143C] rounded-full flex items-center justify-center transition-colors"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/10 hover:bg-[#DC143C] rounded-full flex items-center justify-center transition-colors"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/10 hover:bg-[#DC143C] rounded-full flex items-center justify-center transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-gray-300 hover:text-[#DC143C]">Home</Link></li>
              <li><Link to="/loans" className="text-gray-300 hover:text-[#DC143C]">Loans</Link></li>
              <li><Link to="/portfolio-management" className="text-gray-300 hover:text-[#DC143C]">Portfolio Management</Link></li>
              <li><Link to="/insurance" className="text-gray-300 hover:text-[#DC143C]">Insurance</Link></li>
              <li><Link to="/lending-partners" className="text-gray-300 hover:text-[#DC143C]">Lending Partners</Link></li>
              <li><Link to="/calculators" className="text-gray-300 hover:text-[#DC143C]">Calculators</Link></li>
              <li><Link to="/partner-onboarding" className="text-gray-300 hover:text-[#DC143C]">Partner Onboarding</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4">Our Services</h3>
            <ul className="space-y-3 text-gray-300">
              <li>Home Loans</li>
              <li>Personal Loans</li>
              <li>Portfolio Management</li>
              <li>Mutual Funds</li>
              <li>Insurance Solutions</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#DC143C] mt-0.5" />
                <div>
                  <a
                    href="tel:+9118001234567"
                    className="text-gray-300 hover:text-[#DC143C]"
                  >
                    +91 1800 123 4567
                  </a>
                  <p className="text-sm text-gray-400">
                    Mon–Sat: 9:00 AM – 6:00 PM
                  </p>
                </div>
              </li>

              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#DC143C] mt-0.5" />
                <a
                  href="mailto:info@capitaliq.com"
                  className="text-gray-300 hover:text-[#DC143C]"
                >
                  info@capitaliq.com
                </a>
              </li>

              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#DC143C] mt-0.5" />
                <div className="text-gray-300 leading-relaxed">
                  Capital IQ<br />
                  3rd Floor, ABC Towers<br />
                  Patia, Bhubaneswar – 751001<br />
                  Odisha, India
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} Capital IQ. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-[#DC143C]">Privacy Policy</a>
              <a href="#" className="text-gray-400 hover:text-[#DC143C]">Terms of Service</a>
              <a href="#" className="text-gray-400 hover:text-[#DC143C]">Cookie Policy</a>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;